import React from 'react';
import { inject, observer } from 'mobx-react';
import { Carousel } from 'antd';

import './css';

import MultiLang from './multiLang';
import E7Form from './e7Form';
import E7QRCode from './e7QRCode';
import LoginBtn from './LoginBtn';
import { addContentPath } from '../../../../util/pathUtil';

@inject('portalLoginStore')
@observer
class E7FormCloud extends React.Component {
    constructor(props) {
        super(props);
    }

    state={
        loadFinish: false,
    }

    getState = (props) => {
        if (!props) {
            props = this.props;
        }
        const { portalLoginStore } = this.props;
        const { state = {} } = portalLoginStore;
        const { loginSettingInfo = {} } = state;
        const { loginInfo, loginForm, isRememberPW } = props;

        let _state = Object.assign({}, state);
        let _loginSettingInfo = Object.assign({}, loginSettingInfo);
        if (loginInfo && loginForm) {
            let _loginInfo = Object.assign({}, loginSettingInfo.loginInfo, loginInfo);
            let _loginForm = Object.assign({}, loginSettingInfo.loginForm, loginForm);
            _loginSettingInfo.loginInfo = _loginInfo;
            _loginSettingInfo.loginForm = _loginForm;
            _state.loginSettingInfo = _loginSettingInfo;
            if (isRememberPW) {
                _state.isRememberPW = isRememberPW;
            }
        }
        return _state;
    }

    setLoginType = (props) => {
        const { portalLoginStore } = this.props;
        let { state, setStateAndCache } = portalLoginStore;
        state = this.getState(props);
        const { loginSettingInfo = {} } = state;
        const { showQrcode, defaultQrcode } = loginSettingInfo.loginInfo;
        if (showQrcode && defaultQrcode) {
            setStateAndCache('loginType', 'QRCode');
        } else {
            setStateAndCache('loginType', 'form');
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loginInfo
            && (nextProps.loginInfo.showQrcode != this.props.loginInfo.showQrcode
            || nextProps.loginInfo.defaultQrcode != this.props.loginInfo.defaultQrcode
            || nextProps.loginInfo.onlyQrcode != this.props.loginInfo.onlyQrcode)
        ) {
            this.setLoginType(nextProps);
        }
    }

    componentWillMount() {
        const { portalLoginStore, isNeedGetLoginInfo } = this.props;

        if (isNeedGetLoginInfo == true) {
            portalLoginStore.getLoginInfo();
        } else {
            this.setLoginType();
        }

        this.setState({ loadFinish: true });
    }

    render() {
        const { loadFinish } = this.state;
        if (loadFinish) {
            const { portalLoginStore } = this.props;
            let { state, setStateAndCache, getElementStyle, labelObj } = portalLoginStore;
            state = this.getState();
            const {
                loginSettingInfo = {},
                loginType,
            } = state;
            let { loginInfo, loginForm } = loginSettingInfo;
            const { showQrcode, defaultQrcode, onlyQrcode } = loginInfo;
            const { color = 'rgb(140, 140, 140)', e7Bgi = '/wui/theme/ecology7/page/images/login/login_cbg_wev8.png', e7Silder = '/wui/theme/ecology7/page/images/login/lg_bg1_wev8.jpg,/wui/theme/ecology7/page/images/login/lg_bg2_wev8.jpg,/wui/theme/ecology7/page/images/login/lg_bg3_wev8.jpg',e7SilderAutoPlay='1' } = loginForm;
            let isSetting = false;
            if (this.props.isFormCloudSetting == true) {
                isSetting = true;
            }
            let positionDynamicCss = {};
            if (this.props.isPositionDynamicCss == true) {
                positionDynamicCss = getElementStyle(loginForm);
                positionDynamicCss.position = 'absolute';
            } else {
                positionDynamicCss.position = 'relative';
            }

            return (
                <div className="e7FormCloud" style={{ ...positionDynamicCss, color, 'background-image': `url(${addContentPath(e7Bgi)})` }}>
                    <div className="e7FormCloud-slider">
                        <Carousel ecId={`${this && this.props && this.props.ecId || ''}_Carousel@qprdp9`} autoplay={e7SilderAutoPlay == '1' ? true : false} dots={false}>
                            {
                                e7Silder.split(',').map((item, index) => (
                                        <div className="e7FormCloud-slider-item" key={index}>
                                            <img src={addContentPath(item)} alt="" />
                                        </div>
                                    ))
                            }
                        </Carousel>

                    </div>
                    <div className="e7FormCloud-main">
                        <div className="multilang-qrcode">
                            <MultiLang ecId={`${this && this.props && this.props.ecId || ''}_MultiLang@wzuzkb`} isSetting={isSetting} getState={this.getState} />
                            {
                                (isSetting && showQrcode && !defaultQrcode && !onlyQrcode) || (!isSetting && showQrcode && loginType == 'form') ? (
                                    <i className="qRCode-scan icon-coms-Scan" title={labelObj.smdl} onClick={() => setStateAndCache('loginType', 'QRCode')} />
                                ) : null
                            }
                            {
                                (isSetting && showQrcode && defaultQrcode && !onlyQrcode) || (!isSetting && ((showQrcode && !onlyQrcode) || !showQrcode) && loginType != 'form') ? (
                                    <i className="qRCode-revoke icon-coms-Revoke2" title={labelObj.fh} onClick={() => setStateAndCache('loginType', 'form')} />
                                ) : null
                            }
                        </div>
                        {
                            (isSetting && (!showQrcode || (showQrcode && !defaultQrcode && !onlyQrcode))) || (!isSetting && loginType == 'form') ? <E7Form ecId={`${this && this.props && this.props.ecId || ''}_E7Form@lh9360`} getState={this.getState} /> : <E7QRCode ecId={`${this && this.props && this.props.ecId || ''}_E7QRCode@f70uqt`} getState={this.getState} />
                        }
                        {
                            (isSetting && (!showQrcode || (showQrcode && !defaultQrcode && !onlyQrcode))) || (!isSetting && loginType == 'form') ? <LoginBtn ecId={`${this && this.props && this.props.ecId || ''}_LoginBtn@6x1udf`} isSetting={isSetting} getState={this.getState} /> : null
                        }
                    </div>
                </div>
            );
        }
            return null;
    }
}

export default E7FormCloud;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/e7login/formCloud/index.js